import React, { useMemo } from "react";

import { useTranslation } from "react-i18next";

import InventoryStockItem from "./InventoryStockItem";
import StockMovements from "./stock-movements/StockMovements";

import Tabs from "components/ui/tabs/Tabs";

const StockTabs = ({ itemId, onClose, isNewItem, gotoItem, DeleteItem, UpdateItem, InsertItem }) => {
  const { t } = useTranslation();

  const accountingTabs = useMemo(() => {
    let allTabs = [];

    allTabs.push({
      label: t("stock.stockInfo"),
      content: (
        <InventoryStockItem
          itemId={itemId}
          onClose={onClose}
          isNewItem={isNewItem}
          gotoItem={gotoItem}
          DeleteItem={DeleteItem}
          UpdateItem={UpdateItem}
          InsertItem={InsertItem}
        />
      ),
    });

    allTabs.push({
      label: t("stock.stockMovements"),
      content: <StockMovements stockId={itemId} />,
    });

    return allTabs;
  }, [t, itemId, onClose, isNewItem, gotoItem, DeleteItem, UpdateItem, InsertItem]);

  return (
    <React.Fragment>
      <Tabs tabs={accountingTabs} isVertical={false} />
    </React.Fragment>
  );
};

export default StockTabs;
